import { render } from "./switch-table-item.vue?vue&type=template&id=621bb86f&scoped=true&ts=true"
import script from "./switch-table-item.vue?vue&type=script&lang=ts"
export * from "./switch-table-item.vue?vue&type=script&lang=ts"

import "./switch-table-item.vue?vue&type=style&index=0&id=621bb86f&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621bb86f"]])

export default __exports__